import { Button } from '@/components/ui/button';
import { MutedText } from '@/components/ui/typography';

interface CookieBannerTextProps {
  text: string;
  cookiePolicyHref: string;
}

export function CookieBannerText({ text, cookiePolicyHref }: CookieBannerTextProps) {
  return (
    <MutedText>
      {text}{' '}
      <Button variant="link" asChild>
        <a href={cookiePolicyHref} target="_blank" rel="noopener noreferrer">
          Learn more
        </a>
      </Button>
      .
    </MutedText>
  );
}
